import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

/*
Overview
--------
*/
export default css`
  .Spread__item--profile,
  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  .Spread__items {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0.5rem;
  }

  @media (min-width: 48rem) {
    .Spread__item--ad {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__item--profile,
    .Spread__item--teaser {
      flex: 0 0 25%;
      margin-bottom: 1.5rem;
      max-width: 25%;
      padding: 0 0.75rem;
    }

    .Spread__items {
      padding: 0 1.5rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      width: ${pageWidth.large};
      margin: 0 auto;
      padding: 0;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) {
      .Spread__item--ad {
        grid-column: span 6;
      }

      .Spread__item--profile,
      .Spread__item--teaser {
        margin-bottom: 0;
        max-width: none;
        padding: 0;
      }

      .Spread__item--profile:nth-child(4n + 1),
      .Spread__item--teaser:nth-child(4n + 1) {
        grid-column-start: 2;
      }

      .Spread__items {
        grid-template-columns: 0px repeat(4, 1fr) 0px;
        grid-column-gap: 1.5rem;
        grid-row-gap: 2.25rem;
        padding: 0;
      }
    }

    @media (min-width: 64rem) {
      .Spread__items {
        grid-template-columns: 1fr repeat(4, 226px) 1fr;
        width: 100%;
        margin: 0;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns: 1fr repeat(4, 269px) 1fr;
      }
    }
  }
`;
